import { render } from "./AssetNotificationRules.vue?vue&type=template&id=1adc816d&scoped=true&ts=true"
import script from "./AssetNotificationRules.vue?vue&type=script&lang=ts"
export * from "./AssetNotificationRules.vue?vue&type=script&lang=ts"

import "./AssetNotificationRules.vue?vue&type=style&index=0&id=1adc816d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adc816d"]])

export default __exports__